import { render, staticRenderFns } from "./InteractionsTable.vue?vue&type=template&id=39ac9840&"
import script from "./InteractionsTable.vue?vue&type=script&lang=js&"
export * from "./InteractionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports